// extracted by mini-css-extract-plugin
module.exports = {"MerchantReservationButton":"MerchantReservationButton_MerchantReservationButton__3VWdj"};